define(
    ['jquery', 'can/util/jquery', 'can/view', 'can/view/modifiers'],
    function($, can) {
        $.View = can.view;
        return $;
    }
);
